<div class="flex items-center space-x-16">
  <p class="mt-3" id="cib-last-updated">{{ lastUpdated }}</p>
  <button
    *ngIf="isProxyVoteEnable && isEligible"
    class="p-0 bg-transparent border-none cursor-pointer text-darkBlue-600"
    id="Single-CIB-Proxy-Vote-Button"
    (click)="openProxyVoteModal()"
  >
    Proxy Vote
  </button>
</div>
